import React from 'react';
import { Button } from 'react-bootstrap';

export default ({ text, name, submitAction, isDisabled }) => { // eslint-disable-line
  return (
    <Button
      name={name}
      type="button"
      bsStyle="primary"
      disabled={isDisabled}
      onClick={() => submitAction()}
      style={{ fontSize: 14 }}
    >
      {text}
    </Button>
  );
};



// WEBPACK FOOTER //
// ./components/SecurityBoxSubmit.jsx